
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {

    blockedUserList: null,

    selectedBlockedUser: null,

    isErrorAddBlock: false,
    isLoadingAddBlock: false,

    isErrorGetBlock: false,
    isLoadingGetBlock: false,

    isErrorUpdateBlock: false,
    isLoadingUpdateBlock: false,

    isErrorDeleteBlock: false,
    isLoadingDeleteBlock: false,

    message:null,

}

export const addBlockedUsers = createAsyncThunk("blockedUsers/addBlockedUsers", async(body , thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/RestrictedUsers/CreateRestrictedUser`, body)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Eklendi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
        const rld = JSON.parse(storage.getItem("rld"))
        
        return {data: rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" ? data.data.restrictedUsersDto : data.data.getAllRestrictedUserDto, key: rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" ? "restrictedUsersDto" : "getAllRestrictedUserDto"}

    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const getBlockedUsers = createAsyncThunk("blockedUsers/getBlockedUsers", async(_ , thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/RestrictedUsers/GetAllRestrictedUser`)
        
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const deleteBlockedUsers = createAsyncThunk("blockedUsers/deleteBlockedUsers", async(id , thunkApi)=> {
    try {
        const {data} = await axiosInstance.delete(`/RestrictedUsers/DeleteBlockedUserDetail?Id=${id}`,)
        if (data) {
            thunkApi.dispatch(showModal("result"));
            thunkApi.dispatch(
              setResultModalData({
                msg: "Başarılı Bir Şekilde Silindi.",
                resultType: "success",
                btnText1: "Listeyi Görüntüle",
              })
            );
        }
        
        return data.data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

const blockedUserSlice = createSlice({
    name: "blockedUsers",
    initialState,
    reducers: {
        setSelectedBlockedUser: (state, action) => {
            state.selectedBlockedUser = action.payload
        }
    },
    extraReducers:(builder)=> {
        builder
        
        .addCase(addBlockedUsers.pending, (state)=> {
            state.isLoadingAddBlock = true
        })
        .addCase(addBlockedUsers.fulfilled, (state, action)=> {
            state.isLoadingAddBlock = false
            if(action.payload.key === "restrictedUsersDto"){
                const lastItem = action.payload.data.blockedUserDetails.$values.slice(-1)[0];
                const newItem = {
                    id: action.payload.data.id,
                    phoneNumber: action.payload.data.phoneNumber,
                    fullNameTitle: lastItem.fullNameTitle,
                    nationalId: lastItem.nationalId,
                    description: lastItem.description,
                    createdAt: action.payload.data.createdAt,
                    plateNumbers: lastItem.blockedVehicles.$values
                };

                state.blockedUserList = [...state.blockedUserList, newItem]; 
            }else{
                state.blockedUserList = [...state.blockedUserList , {...action.payload.data, plateNumbers: action.payload.data.plateNumbers.$values}]
            }
        })
        .addCase(addBlockedUsers.rejected, (state, action)=> {
            state.isLoadingAddBlock = false
            state.isErrorAddBlock = true
        })

        .addCase(getBlockedUsers.pending, (state)=> {
            state.isLoadingGetBlock = true
        })
        .addCase(getBlockedUsers.fulfilled, (state, action)=> {
            state.isLoadingGetBlock = false
            state.blockedUserList = action.payload.$values.map((item) => {
                return {
                    ...item,
                    plateNumbers: item.plateNumbers.$values
                }
            })
        })
        .addCase(getBlockedUsers.rejected, (state, action)=> {
            state.isLoadingGetBlock = false
            state.isErrorGetBlock = true
        })

        .addCase(deleteBlockedUsers.pending, (state)=> {
            state.isLoadingDeleteBlock = true
        })
        .addCase(deleteBlockedUsers.fulfilled, (state, action)=> {
            state.isLoadingDeleteBlock = false
            state.blockedUserList = state.blockedUserList.filter((item) => {
                return item.id !== action.payload.id
            })
        })
        .addCase(deleteBlockedUsers.rejected, (state, action)=> {
            state.isLoadingDeleteBlock = false
            state.isErrorDeleteBlock = true
        })


    }
})


export const {setSelectedBlockedUser} = blockedUserSlice.actions
export default blockedUserSlice.reducer